import React from 'react';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import { Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import { withTheme } from 'styled-components';
import styles from './banner.module.scss';

import { Box, ButtonNew, Text } from 'components/Wrapped';
import { Form, TextField } from 'components/Form';
import { Video } from 'grommet';

const Banner = withNamespaces()(({ isAuthenticated, t: translate, size }) => {
  // const t = nestedTranslate(translate, 'sections');
  const history = useHistory();

  const logInValidationSchema = () =>
    Yup.object().shape({
      email: Yup.string()
        .email()
        .required(),
    });

  const handleSubmit = (data) => {
    history.push('/signup', { email: data.email });
  };

  return (
    <Box
      align="start"
      justify="center"
      pad={{
        horizontal: size === 'small' ? '30px' : '80px',
        vertical: size === 'small' ? '30px' : '80px',
      }}
      height="900px"
      className={styles.root}
      style={{
        marginTop: size === 'small' ? '-205px' : '0px',
      }}
    >
      <Box
        pad="none"
        style={{
          position: 'absolute',
          top: size === 'small' ? '602px' : 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 1,
        }}
      >
        <Video
          src="/assets/videos/banner_bg.mp4"
          playsInline
          controls={false}
          autoPlay
          loop
          mute
          type="video/mp4"
          style={{
            height: 'auto',
            width: 'auto',
            objectFit: size === 'small' ? 'cover' : 'initial',
            objectPosition: size === 'small' ? 'right' : 'initial',
          }}
        />
      </Box>
      <Box
        align="start"
        pad="none"
        direction="column"
        width={{ max: size === 'small' ? 'auto' : '540px' }}
        style={{
          marginLeft: size === 'small' ? 'auto' : '0px',
          marginRight: size === 'small' ? 'auto' : '0px',
        }}
        className={styles.textInfoBlock}
      >
        <Text
          color="white"
          size={size === 'small' ? '36px' : '64px'}
          weight="bold"
          margin={{ bottom: size === 'small' ? '15px' : '20px' }}
          style={{
            lineHeight: size === 'small' ? '36px' : '64px',
            width: size === 'small' ? '235px' : '410px',
            textAlign: size === 'small' ? 'center' : 'left',
            marginLeft: size === 'small' ? 'auto' : '0px',
            marginRight: size === 'small' ? 'auto' : '0px',
          }}
        >
          Безопасная и выгодная криптобиржа
        </Text>
        <Text
          color="rgba(255,255,255,0.7)"
          size={size === 'small' ? '18px' : '20px'}
          margin={{ bottom: '30px' }}
          style={{
            lineHeight: size === 'small' ? '23.4px' : '26px',
            textAlign: size === 'small' ? 'center' : 'left',
          }}
        >
          Зарегистрируйтесь, торгуйте и зарабатывайте
        </Text>
        {!isAuthenticated ? (
          <Box
            pad="none"
            width="400px"
            style={{
              position: 'relative',
              marginLeft: size === 'small' ? 'calc(auto - 5px)' : '0px',
              marginRight: size === 'small' ? 'auto' : '0px',
            }}
          >
            <Formik
              initialValues={{
                email: '',
              }}
              onSubmit={(values) => handleSubmit(values)}
              validationSchema={logInValidationSchema}
            >
              <Form>
                <TextField
                  type="text"
                  name="email"
                  placeholder="Email"
                  persistentPlaceholder={false}
                  background="#00000066"
                  style={{ padding: '23px 16px' }}
                />
                <Box pad="none" style={{ position: 'absolute', right: '16px', top: '12px' }}>
                  <ButtonNew type="submit" label="Начать" />
                </Box>
              </Form>
            </Formik>
          </Box>
        ) : (
          <Box direction="row" gap="10px" pad="none">
            <ButtonNew label="Депозит" buttonSize="large" width="140px" />
            <ButtonNew label="Торговать" theme="black" buttonSize="large" width="140px" />
          </Box>
        )}
      </Box>
    </Box>
  );
});

const mapStateToProps = ({
  auth,
  exchangeSettings: {
    settings: {
      seo: { reCaptchaKey },
    },
  },
}) => ({ isAuthenticated: auth.isAuthenticated, reCaptchaKey });

export default withTheme(connect(mapStateToProps)(Banner));
